import { render, staticRenderFns } from "./AccessoryReference.vue?vue&type=template&id=5445d83e&scoped=true"
import script from "./AccessoryReference.vue?vue&type=script&lang=js"
export * from "./AccessoryReference.vue?vue&type=script&lang=js"
import style0 from "./AccessoryReference.vue?vue&type=style&index=0&id=5445d83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445d83e",
  null
  
)

export default component.exports